export class Diversos{
    constructor(
        public nombre: String,
        public diverso: Number,
        public tipo_diverso: String,
        public tipo_presupuesto: String

    ){}
}